import { UseMutationResult, useMutation } from 'react-query'
import request from '../request'
import { User } from '../../lib/types/User'

export const useEditUser = (): UseMutationResult<
  unknown,
  Error,
  { user_id: number; data: Partial<User> }
> => {
  return useMutation(({ user_id, data }: { user_id: number; data: Partial<User> }) =>
    request({
      url: `/user/${user_id}`,
      method: 'PATCH',
      data,
    }),
  )
}
